import HttpUser from '@/http/bhiotrack';

const forgotPassword = (email) => {
  return HttpUser.post(`/auth/forgotpassword`, { email });
};
const resetPassword = (body) => {
  return HttpUser.put(`/auth/resetpassword`, body);
};
const changePassword = (body) => {
  return HttpUser.put(`/auth/changepassword`, body);
};
const refreshToken = (params) => HttpUser.put(`/user/token`, params);
const loginUser = (params) => HttpUser.post(`/auth/login`, params);

export const authService = {
  forgotPassword,
  resetPassword,
  changePassword,
  refreshToken,
  loginUser,
};
